import React, { useEffect, useState } from "react";
import styles from "./PaginaLader.module.css";

interface PaginaLaderProps {
  /** "fullscreen" vult het hele venster (bv. auth-check), "inline" de content-zone. */
  variant?: "fullscreen" | "inline";
  /** Tekst onder de spinner. */
  tekst?: string;
  /** Wachttijd in ms vóór de spinner verschijnt — voorkomt flikkeren bij snelle loads. */
  vertraging?: number;
}

/**
 * Rustige, branded laad-indicator. Toont een gecentreerde spinner met tekst.
 * Verschijnt pas na `vertraging` ms, zodat snelle loads niet flikkeren.
 */
const PaginaLader: React.FC<PaginaLaderProps> = ({
  variant = "inline",
  tekst = "Bezig met laden…",
  vertraging = 200,
}) => {
  const [zichtbaar, setZichtbaar] = useState(vertraging === 0);

  useEffect(() => {
    if (vertraging === 0) return;
    const timer = window.setTimeout(() => setZichtbaar(true), vertraging);
    return () => window.clearTimeout(timer);
  }, [vertraging]);

  if (!zichtbaar) return null;

  return (
    <div
      className={variant === "fullscreen" ? styles.fullscreen : styles.inline}
      role="status"
      aria-live="polite"
    >
      <div className={styles.spinner} aria-hidden="true" />
      <span className={styles.tekst}>{tekst}</span>
    </div>
  );
};

export default PaginaLader;
